import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    tab: {
        color: '#131313 !important',
        fontWeight: 'bold',
        '& .Mui-selected': { color: '#137DC5 !important' },
        '& .MuiTabs-indicator': {
            backgroundColor: '#137DC5',
        },
    },
}));
